export enum PaginationActionType {
  PAGINATION_SET_PAGE_NUMBER = 'PAGINATION_SET_PAGE_NUMBER',
}
